module.exports = __webpack_public_path__ + "img/0Q3B8360-70_H_Foamcore.ccd21253.jpg";